import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd5b8588"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-block" }
const _hoisted_2 = ["href", "onClick"]

import { inject, onMounted, ref } from 'vue';
import { SmoothScrollOptions } from 'vue3-smooth-scroll';


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuBlock',
  props: {
    menuItems: {}
  },
  setup(__props: any) {

const props = __props;

const activeMenuItemId = ref('');
const smoothScroll = inject('smoothScroll') as (args: SmoothScrollOptions) => void;
const changeMenuItem = (menuItemId: string) => {
  const myEl = document.getElementById(menuItemId);

  if (myEl) {
    smoothScroll({
      scrollTo: myEl,
      offset: 0,
    });
  }

  activeMenuItemId.value = menuItemId;
};

onMounted(() => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        activeMenuItemId.value = entry.target.getAttribute('id') ?? '';
      }
    });
  });

  document.querySelectorAll('.section').forEach(section => {
    observer.observe(section);
  });
});

return (_ctx: any,_cache: any) => {
  const _component_base_divider = _resolveComponent("base-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id
      }, [
        _createElementVNode("a", {
          class: _normalizeClass([{ 'gradient-color': activeMenuItemId.value !== item.id }, "menu-block__item"]),
          href: `#${item.id}`,
          onClick: ($event: any) => (changeMenuItem(item.id))
        }, _toDisplayString(item.title), 11, _hoisted_2),
        (i !== _ctx.menuItems.length - 1)
          ? (_openBlock(), _createBlock(_component_base_divider, { key: 0 }))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})